/**
 * authorization redux reducer
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


import {LOGIN_SUCCESS, LOGOUT} from "./consts";


const initialState = {
    accessToken: undefined,
    userInfo: undefined,
    roleInfo: [],
    typeInfo: {},
    userPrivileges: {}
};


export default function authorizationReducer(state = initialState, action) {

    switch(action.type) {

        case LOGIN_SUCCESS:

            let privileges = {}
            for (const key of action.userInfo['privileges']) {
                privileges[key] = true;
            }

            return {
                ...state,
                accessToken: action.accessToken,
                userInfo: action.userInfo,
                roleInfo: action.roleInfo,
                typeInfo: action.typeInfo,
                userPrivileges: privileges
            };

        case LOGOUT:

            return initialState;

        default:
            return state;
    }
}
